import {FC} from 'react'

interface Props {
    booking: Booking
}

const Loader: FC<Props> = ({booking}) => {
    if (!booking.loading)
        return

    return (
        <div className={'woocommerce'}>
            <div className={'loader'}></div>
        </div>
    )
};

export default Loader